import { FETCH_GOLF_COURSE, FETCH_GOLF_COURSE_SUCCESS, FETCH_GOLF_COURSE_FAIL } from 'actions/golfCourseActions.js';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING'
};

const INITIAL_STATE = {
    golfCourses: {},
    networkingStatus: NETWORKING_STATUSES.SUCCESS
};

const fetchGolfCourseSuccess = (state, action) => {
    return {
        golfCourses: {
            ...state.golfCourses,
            [action.golfCourse.courseSnapshotId]: action.golfCourse
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchGolfCourseStart = (state, action) => {
    return {
        golfCourses: {
            ...state.golfCourses
        },
        networkingStatus: NETWORKING_STATUSES.FETCHING
    };
};

const fetchGolfCourseFail = (state, action) => {
    return {
        golfCourses: {
            ...state.golfCourses
        },
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const handlers = {
    [FETCH_GOLF_COURSE_SUCCESS]: fetchGolfCourseSuccess,
    [FETCH_GOLF_COURSE]: fetchGolfCourseStart,
    [FETCH_GOLF_COURSE_FAIL]: fetchGolfCourseFail
};

export default function golfCourse(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchGolfCourse(courseSnapshotId, userLocale, evictCache) {
    return {
        type: FETCH_GOLF_COURSE,
        courseSnapshotId: courseSnapshotId,
        userLocale: userLocale,
        meta: {
            cacheTime: evictCache ? null : 60000
        }
    };
}

// Getters
export const getGolfCourses = (state) => {
    const keys = Object.keys(state.golfCourse.golfCourses);
    const golfCourses = keys.map((key) => state.golfCourse.golfCourses[key]);
    return golfCourses;
};

export const getGolfCourse = (state, courseSnapshotId) => {
    return state.golfCourse.golfCourses[courseSnapshotId] || {};
};

export const getGolfCourseNetworkStatus = (state) => {
    return state.golfCourse.networkingStatus;
};

export const getGolfCourseFromDate = (state, courseGlobalId, fromDate) => {
    return state.golfCourseStats.golfCourses.find((golfCourse) => {
        return golfCourse.courseGlobalId === courseGlobalId && golfCourse.releaseDate === fromDate;
    });
};

export const isGolfCourseFetching = (state) => {
    return state.golfCourse.networkingStatus === NETWORKING_STATUSES.FETCHING;
};

export const didGolfCourseFetchFail = (state) => {
    return state.golfCourse.networkingStatus === NETWORKING_STATUSES.FAIL;
};

export const didGolfCourseFetchSucceed = (state) => {
    return state.golfCourse.networkingStatus === NETWORKING_STATUSES.SUCCESS;
};
